import React from 'react';
import cn from 'classnames';

import LabelElement from '../_elements/labelElement/labelElement';

import styles from './select.module.scss';

const Select = ({
  options,
  name,
  label,
  onChange,
  selectedValue,
  disabled = false,
  className,
  labelContainerClassName,
}) => {
  const renderOptions = () =>
    options.map(({ name, value, disabled: optionDisabled = false }) => (
      <option key={value} value={value} disabled={optionDisabled}>
        {name}
      </option>
    ));

  return (
    <>
      {label && (
        <div className={cn(styles.labelContainer, labelContainerClassName)}>
          <LabelElement label={label} htmlFor={name} />
        </div>
      )}
      <select
        name={name}
        className={cn(styles.select, className)}
        onChange={onChange}
        value={selectedValue}
        disabled={disabled}
      >
        {renderOptions()}
      </select>
    </>
  );
};

export default Select;
